const availableModulesConstants = Object.freeze({
  BUDGETS: 'budgets',
  CARDS: 'cards',
  EXPENSES: 'expenses',
  SSO: 'sso',
  SUBSCRIPTIONS: 'subscriptions',
  TRANSACTIONS: 'transactions'
});
export {availableModulesConstants};
